module.exports = __webpack_public_path__ + "img/1.b4683702.jpg";